if (!customElements.get('oa-home-reviews')) {
  customElements.define('oa-home-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      const track = this.querySelector('.oa-reviews__track');
      const prev = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      const reviewCards = [...this.querySelectorAll('.oa-review')];
      reviewCards.forEach(card => {
        const body = card.querySelector('.oa-review__body');
        const button = card.querySelector('[data-review-expand]');
        button.addEventListener('click', () => {
          const expanded = body.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? 'Read less' : 'Read more';
        }, options);
      });
      const update = () => {
        reviewCards.forEach(card => {
          const body = card.querySelector('.oa-review__body');
          const button = card.querySelector('[data-review-expand]');
          button.hidden = !body.classList.contains('is-expanded') && body.scrollHeight <= body.clientHeight + 1;
        });
        prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;};
      const move = direction => track.scrollBy({left: direction * (track.querySelector('.oa-review').getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, {...options, passive: true});
      track.addEventListener('keydown', event => {if(event.key === 'ArrowRight' || event.key === 'ArrowLeft'){event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);}}, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();}
  });
}
